export const categoryTreeModeEnum =
{
    default: 'default',
    leafOnly: 'leafOnly'
};